import AnimatedText from "../AnimationLetterAbout/AnimationLetterAbout";

const About = (props) => {
  return (
    <div id="about">
      <div id="containeTextAbout">
        <AnimatedText
          textArray={[
            " Issu du secteur de la logistique, j’ai opéré une reconversion vers le domaine de l’informatique, guidé par une véritable passion pour les technologies du web. Je me spécialise actuellement dans le développement front-end, avec l’ambition d’évoluer à moyen terme vers un profil full-stack afin de maîtriser l’ensemble de la chaîne de développement d’une application web",
          ]}
        />
      </div>
    </div>
  );
};

export default About;
